import * as React from 'react';

const SvgInternet = (props) => (
  <svg
    width={42}
    height={42}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#Internet_svg__a)' fill='#858585'>
      <path d='M21 39.813C10.623 39.813 2.187 31.377 2.187 21 2.188 10.623 10.623 2.187 21 2.187c10.378 0 18.813 8.436 18.813 18.813 0 10.378-8.436 18.813-18.813 18.813Zm0-35C12.075 4.813 4.812 12.075 4.812 21S12.075 37.188 21 37.188c8.925 0 16.188-7.263 16.188-16.188 0-8.925-7.263-16.188-16.188-16.188Z' />
      <path d='M15.75 38.063H14a1.322 1.322 0 0 1-1.313-1.313c0-.718.56-1.295 1.278-1.313a51.608 51.608 0 0 1 0-28.874 1.303 1.303 0 0 1-1.278-1.313c0-.718.595-1.313 1.313-1.313h1.75c.42 0 .822.21 1.067.543.245.35.315.787.175 1.19-3.29 9.887-3.29 20.773 0 30.677.14.403.07.84-.175 1.19a1.378 1.378 0 0 1-1.067.526ZM26.25 38.062c-.14 0-.28-.018-.42-.07-.682-.228-1.067-.98-.822-1.663 3.29-9.887 3.29-20.772 0-30.677a1.31 1.31 0 1 1 2.485-.84c3.482 10.43 3.482 21.91 0 32.322-.175.578-.7.928-1.243.928Z' />
      <path d='M21 30.1c-4.883 0-9.748-.683-14.438-2.066a1.315 1.315 0 0 1-1.312 1.278 1.322 1.322 0 0 1-1.313-1.313v-1.75c0-.42.21-.822.543-1.067.35-.245.787-.315 1.19-.175 9.887 3.29 20.79 3.29 30.677 0 .403-.14.84-.07 1.19.175s.543.647.543 1.067V28c0 .718-.595 1.313-1.313 1.313-.717 0-1.295-.56-1.312-1.278A51.268 51.268 0 0 1 21 30.1ZM36.75 17.063c-.14 0-.28-.017-.42-.07-9.887-3.29-20.79-3.29-30.677 0a1.31 1.31 0 0 1-1.663-.822c-.21-.7.158-1.435.84-1.663 10.43-3.482 21.91-3.482 32.323 0 .682.228 1.067.98.822 1.663-.157.542-.682.892-1.225.892Z' />
    </g>
    <defs>
      <clipPath id='Internet_svg__a'>
        <path fill='#fff' d='M0 0h42v42H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgInternet;
